import React from 'react'
import { Button } from 'antd'
import { DashboardOutlined } from '@ant-design/icons'
import { useHistory } from 'react-router-dom'

export const AIC_DASHBOARD_PATH = '/portal/aic-dashboard/v2/overview'
export const AIC_SKILL_TAB_PATH = '/portal/profile?tab=skillmarket'

/**
 * 个人中心「AIC 数据资产」tab 的入口卡片（P5）。
 * 看板已承接数据源、上传人、授权、健康与异常，个人中心这一 tab 只保留跳转入口，
 * 不再承载数据登记/上传（改为 AIC Skill 在 Codex 中完成）。
 * 原 AicDataAssetTab.js 保留不删除，只是不再从这里渲染。
 */
export default function AicDashboardEntryCard () {
  const history = useHistory()
  return <div className="profile-aic-entry">
    <div className="profile-aic-entry-main">
      <div className="profile-aic-entry-icon"><DashboardOutlined /></div>
      <div className="profile-aic-entry-copy">
        <div className="profile-aic-entry-title">AIC 数据看板</div>
        <div className="profile-aic-entry-desc">
          数据源、上传人、授权、健康与异常都在 AIC 看板维护；数据登记与上传请通过 AIC Skill 在 Codex 中完成。
        </div>
      </div>
    </div>
    <div className="profile-aic-entry-actions">
      <Button type="primary" onClick={() => history.push(AIC_DASHBOARD_PATH)}>
        打开 AIC 看板
      </Button>
      <Button type="link" onClick={() => history.push(AIC_SKILL_TAB_PATH)}>
        安装/查看 AIC Skill
      </Button>
    </div>
  </div>
}
